import { Row } from 'antd';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

export const ActionBar = styled(Row)`
  margin-bottom: 18px;
`;

export const StyledContainer = styled.div`
  .draft > td:not(.actions) {
    opacity: 0.5;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    text-align: center !important;
    vertical-align: middle !important;
    font-size: 12px;
    padding: 8px 10px !important;
  }

  .ant-table-thead > tr > th {
    white-space: nowrap;
    font-weight: 500;
  }

  .actions {
    min-width: 130px !important;
    width: 130px !important;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .ant-table-thead > tr > th.actions {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ant-table-thead > tr > th.actions.ant-table-cell-fix-right {
    background: ${APP_SHELL_THEME.tableFixedHeaderBg} !important;
    z-index: 4 !important;
  }

  .ant-table-tbody > tr > td.actions.ant-table-cell-fix-right {
    background: ${APP_SHELL_THEME.tableFixedBodyBg} !important;
    z-index: 2 !important;
  }

  .ant-table-tbody > tr:hover > td.actions.ant-table-cell-fix-right {
    background: ${APP_SHELL_THEME.tableFixedBodyHoverBg} !important;
  }

  .ant-table-tbody > tr.ant-table-row-selected > td.actions.ant-table-cell-fix-right {
    background: ${APP_SHELL_THEME.tableFixedBodySelectedBg} !important;
  }

  .ant-table-thead > tr > th.actions.ant-table-cell-fix-right-first::after {
    box-shadow: none !important;
    background: ${APP_SHELL_THEME.tableFixedHeaderBg} !important;
  }

  .ant-table-tbody > tr > td.actions.ant-table-cell-fix-right-first::after {
    box-shadow: none !important;
    background: ${APP_SHELL_THEME.tableFixedBodyBg} !important;
  }

  .ant-table-tbody > tr:hover > td.actions.ant-table-cell-fix-right-first::after {
    background: ${APP_SHELL_THEME.tableFixedBodyHoverBg} !important;
  }

  .draft > td.actions.ant-table-cell-fix-right {
    opacity: 1;
  }
`;
